if (!customElements.get('lotus-bundle-form')) {
  customElements.define(
    'lotus-bundle-form',
    class LotusBundleForm extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('form');
        this.button = this.querySelector('[type="submit"]');
        this.label = this.querySelector('.lf-interest__bundle-label');
        this.status = this.querySelector('.lf-interest__status');
        this.defaultLabel = this.label?.textContent;

        if (!this.form || !this.button || this.dataset.initialized === 'true') return;

        this.dataset.initialized = 'true';
        this.form.addEventListener('submit', this.onSubmit.bind(this));
      }

      async onSubmit(event) {
        event.preventDefault();
        if (this.button.getAttribute('aria-disabled') === 'true') return;

        const itemInputs = this.form.querySelectorAll('input[name$="[id]"]');
        const items = Array.from(itemInputs, (input) => ({ id: Number(input.value), quantity: 1 }));
        const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        const payload = { items };

        if (cart) {
          payload.sections = cart.getSectionsToRender().map((section) => section.id);
          payload.sections_url = window.location.pathname;
          cart.setActiveElement(this.button);
        }

        this.setLoading(true);
        this.showStatus();

        try {
          const config = fetchConfig();
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          config.body = JSON.stringify(payload);

          const response = await fetch(routes.cart_add_url, config);
          const parsedState = await response.json();

          if (!response.ok || parsedState.status) {
            throw new Error(parsedState.description || parsedState.message || this.dataset.errorLabel);
          }

          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'lotus-bundle-form',
              productVariantId: items.map((item) => item.id).join(','),
            });
          }

          if (this.label) this.label.textContent = this.dataset.addedLabel;

          if (cart) {
            cart.classList.remove('is-empty');
            cart.renderContents(parsedState);
          } else {
            window.location = window.routes.cart_url;
          }
        } catch (error) {
          this.showStatus(error.message || this.dataset.errorLabel);
        } finally {
          this.setLoading(false);
          window.setTimeout(() => {
            if (this.label && this.isConnected) this.label.textContent = this.defaultLabel;
          }, 1800);
        }
      }

      setLoading(isLoading) {
        this.button.classList.toggle('is-loading', isLoading);
        this.button.setAttribute('aria-disabled', String(isLoading));
      }

      showStatus(message = '') {
        if (!this.status) return;
        this.status.textContent = message;
        this.status.hidden = !message;
      }
    }
  );
}
